import { AdditionalServicesFields, Answer } from '../programTabComponents/AdditionalServices/types';

export const defaultAnswers: Answer[] = [{ text: '' }, { text: '' }];

export const getCreateAdditionalServiceDefaultValues = (): Partial<AdditionalServicesFields> => ({
  repeatable: false,
  answers: defaultAnswers,
});
